module.exports = "/img/_/_/_/assets/images//frame_big.png?af965170cd595ade789c8a56a29a3a20";